import Guess from "./Guess";
import AnswerInput from "./AnswerInput";
import React from "react";

class WordArea extends React.Component {
  componentDidMount() {
    this.props.submit(this.submit);
  }

  render() {
    return (
      <div className="word-area" style={{ "--word-length": this.props.target.length }}>
        {this.props.guesses.map((word) => <Guess key={word} word={word} target={this.props.target} />)}
        < AnswerInput
          target={this.props.target}
          input={this.props.input}
          swapInPuzzle={this.props.swapInPuzzle}
          clearInput={this.props.clearInput}
          submit={call => this.submit = call}
        />
      </div>
    );
  }
}

export default WordArea;